<template>
  <div class="submission-grid">
    <modal
      type="delete"
      @confirm="deleteHandler"
      @cancelled="cancelHandler"
      title="Remove submission"
      v-model="showConfirmation"
    >
      Are you sure you want to remove this submission?
    </modal>
    <submission-grid-item
      v-for="submission in submissions"
      :key="submission.id"
      :submission="submission"
      @delete="trashSubmission"
    ></submission-grid-item>

    <div
      v-if="submissions.length < 8"
      class="submission-grid__item submission-grid__item--add-new"
    >
      <app-button
        variant="cta"
        @click.native="$emit('addNew')"
        class="mb-2"
        align="center"
        >Add submission</app-button
      >
      <span><app-date prepend="Deadline" :date="deadline"/></span>
    </div>
    <div v-else class="submission-grid-item submission-grid__item--full">
      <span class="title-large">Wow!</span>
      You've been busy for this study and reached the 8 submissions per study
      limit.
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AppDate from '@/components/app/AppDate';
import SubmissionGridItem from './SubmissionGridItem';

export default {
  name: 'submission-grid',
  data: function() {
    return {
      showConfirmation: false,
      selectedForDelete: null,
    };
  },
  components: { AppDate, SubmissionGridItem },
  methods: {
    ...mapActions('mySubmissions', ['deleteSubmission', 'markSubmission']),
    markHandler(id) {
      this.$gtag.event('mark_for_critique', {
        event_category: 'participation',
        event_label: 'Mark submission for critique',
      });
      this.markSubmission({
        studyId: this.$route.params.id,
        submissionId: id,
      });
    },
    trashSubmission(id) {
      this.selectedForDelete = id;
      this.showConfirmation = true;
    },
    cancelHandler() {
      this.selectedForDelete = null;
      this.showConfirmation = false;
    },
    deleteHandler() {
      this.deleteSubmission({
        studyId: this.$route.params.id,
        submissionId: this.selectedForDelete,
      });
      this.$gtag.event('delete_submission', {
        event_category: 'participation',
        event_label: 'Delete user submission',
      });
      this.selectedForDelete = null;
    },
  },
  computed: {
    ...mapState('study', {
      deadline: state => state.deadline,
    }),
    ...mapState('mySubmissions', {
      submissions: state => state.submissions,
    }),
    showingTrash() {
      const now = new Date().toLocaleString();
      return Math.abs(new Date(this.deadline) - new Date(now)) / 36e5 > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
$map-grid: (
  '500px': 2,
  '768px': 3,
  '1366px': 4,
);

.submission-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);

  @each $breakpoint, $qty in $map-grid {
    @media screen and (min-width: $breakpoint) {
      grid-template-columns: repeat($qty, 1fr);
    }
  }

  &__item {
    display: flex;
    position: relative;

    img {
      max-width: 100%;
    }

    .submission-tag {
      position: absolute;
      padding: 0.25rem 0.5rem;
      font-size: calc-font-size(12);
      right: 0;
      background: color('primary');
      color: color('primary', 'text');

      &--critique {
        background: color('secondary');
        color: color('secondary', 'text');
      }
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      color: white;
      background: rgba(black, 0.5);
      opacity: 0;
      pointer-events: none;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &:hover {
      .overlay {
        pointer-events: all;
        opacity: 1;
        backdrop-filter: blur(6px);
      }
    }

    &--full,
    &--add-new {
      width: 100%;
      height: 100%;
      background: color('background', 'dark');
      display: flex;
      flex-direction: column;
      text-align: center;
      align-items: center;
      justify-content: center;
      color: color('text', 'light');
      font-weight: 500;
      font-size: calc-font-size(16);
    }

    &--add-new {
      min-height: 200px;
    }

    &--full {
      background: color('background');
      padding: 1rem;
      font-weight: 400;

      .title-large {
        margin-bottom: 1rem;
      }
    }
  }
}
</style>
